import Widget from 'models/dashboard/widget'


Widget.SwissLogoWidget = Widget.extend({});

export default Widget.SwissLogoWidget;

